import { getFrontImageUrl } from "../../../../front/staticServerRendering/frontImage";
import { ImageSize } from "../../../../constants/imageSizes";
import { AudioArticlesRecommendationsItem } from "./audioArticlesRecommendationsInterfaces";

export type AudioArticlesRecommendationsAction = "youtube" | "apple" | "spotify" | "share";

export type ProcessedAudioArticlesRecommendationsItem = AudioArticlesRecommendationsItem & {
    categoryIconSrc?: string;
    imageUrl?: string;
};

export function formatDuration(durationInSeconds: number): string {
    if (!durationInSeconds) {
        return "";
    }
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    return [hours, minutes, seconds].map((value) => value.toString().padStart(2, "0")).join(":");
}

export function resolveImageSrc(imageUrl: string, imagesDomain: string): string {
    const frontImageUrl = imageUrl ? getFrontImageUrl({ publishedLink: imageUrl } as any, { imageSize: ImageSize.medium }) : "";
    if (!frontImageUrl) {
        return "";
    }
    if (frontImageUrl.startsWith("//") || frontImageUrl.startsWith("http")) {
        return frontImageUrl;
    }
    return frontImageUrl.startsWith("/")
        ? imagesDomain + frontImageUrl
        : imagesDomain + "/" + frontImageUrl;
}

interface PodcastShareLinks {
    google: string;
    apple: string;
    spotify: string;
    youtube: string;
}

declare let window: Window & {
    podcastsShareLinksList: { [categoryId: string]: PodcastShareLinks };
};

export function buildActionHref(
    action: AudioArticlesRecommendationsAction,
    itemId: string,
    categoryId?: string,
    isNative?: boolean
): string {
    if (action === "share") {
        return itemId ? `share_article_audio/${itemId}` : "share_article_audio";
    }

    const podcastsShareLinksList = typeof window !== "undefined" && window.podcastsShareLinksList;
    const categoryShareLinks = podcastsShareLinksList && categoryId && podcastsShareLinksList[categoryId]
        ? podcastsShareLinksList[categoryId]
        : null;

    return categoryShareLinks && categoryShareLinks[action] ? categoryShareLinks[action] : "";
}
